import { Link } from "react-router-dom";
import OfferedFoods from "../FeaturedItems/FeaturedItems";
import InstantItems from "../InstantItems/InstantItems";
import PreOrderItems from "../PreOrderItems/PreOrderItems";
import ReadyMadeItems from "../ReadyMadeItems/ReadyMadeItems";
import { FOOD_TYPE } from "../../../services/normalizers";

const FoodSection = ({ data, isPending }) => {
  const sellerRef = { _id: data?._id, name: data?.name, kitchenLogo: data?.kitchenLogo };
  const enrich = (foods) => foods?.map(f => ({ ...f, sellerId: (f?.sellerId && typeof f.sellerId === "object") ? f.sellerId : sellerRef }));

  const offeredFoods = enrich(data?.foods?.filter(food => food?.discountValue > 0));
  const instantFoods = enrich(data?.foods?.filter(food => food?.type === FOOD_TYPE.READY_TO_EAT));
  const readyMadeFoods = enrich(data?.foods?.filter(food => food?.type === FOOD_TYPE.E_SHOP));
  const preOrderFoods = enrich(data?.foods?.filter(food => food?.type === FOOD_TYPE.PRE_ORDER));

  if (data?.foods?.length === 0 && !isPending) return null;

  return (
    <div>
      {offeredFoods?.length > 0 && !isPending && <OfferedFoods foods={offeredFoods} sellerId={data?._id} />}
      {instantFoods?.length > 0 && !isPending && <InstantItems foods={instantFoods} sellerId={data?._id} />}
      {readyMadeFoods?.length > 0 && !isPending && <ReadyMadeItems foods={readyMadeFoods} sellerId={data?._id} />}
      {preOrderFoods?.length > 0 && !isPending && <PreOrderItems foods={preOrderFoods} sellerId={data?._id} />}

      <div className="home-content-shell" style={{ marginBottom: 24 }}>
        <Link
          to={`/wish-order?sellerId=${data?._id}`}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            padding: "12px",
            backgroundColor: "#111827",
            color: "#FFD504",
            fontWeight: 700,
            fontSize: 14,
            fontFamily: "'Inter', sans-serif",
            borderRadius: 10,
            textDecoration: "none",
            letterSpacing: 0.5,
          }}
        >
          Wish Your Food
        </Link>
      </div>
    </div>
  );
};

export default FoodSection;
